// extracted by mini-css-extract-plugin
export default {"label":"ci_label__a5jeb","c":"ci_c__tA+D6","e":"ci_e__0eakK","icon":"ci_icon__85t6c","tx":"ci_tx__ZARyD"};